
// import React, { useState, useEffect } from 'react';
// import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
// import { 
//   FiHome, FiBriefcase, FiUsers, FiBarChart2, FiMail, FiClipboard, FiFileText,
//   FiMap, FiLogOut, FiMenu, FiX, FiFilePlus, FiPlusCircle, FiList, FiChevronDown,
//   FiCreditCard, FiGift, FiTag, FiUserCheck, FiStar, FiTrendingUp, FiZap,
//   FiGrid, FiActivity, FiAward, FiHeart, FiCompass, FiShare2, FiCheckSquare, FiPlus, FiFolder,
//   FiFile, FiUpload, FiFolderPlus, FiBookOpen, FiEdit, FiLayers
// } from 'react-icons/fi';
// import { motion, AnimatePresence } from 'framer-motion';
// import axios from 'axios';

// const AdminLayout = () => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);
//   const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [hoveredItem, setHoveredItem] = useState(null);
//   const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
//   const [walletCoins, setWalletCoins] = useState(null);
//   const [walletLoading, setWalletLoading] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [showLogoutDialog, setShowLogoutDialog] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const fetchWalletData = async () => {
//     const clientId = localStorage.getItem('clientId');
//     if (!clientId) return;
//     setWalletLoading(true);
//     try {
//       const response = await axios.get(`https://api.ingrainsystems.com/api/clients/my-wallet/${clientId}`);
//       if (response.data.success) {
//         setWalletCoins(response.data.data.totalCoins);
//       }
//     } catch (error) {
//       console.error('Error fetching wallet data:', error);
//     } finally {
//       setWalletLoading(false);
//     }
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth < 1024;
//       setIsMobile(mobile);
//       if (mobile) {
//         setIsSidebarOpen(false);
//       } else {
//         setIsSidebarOpen(true);
//       }
//     };
//     handleResize();
//     window.addEventListener('resize', handleResize);
//     fetchWalletData();
//     const interval = setInterval(fetchWalletData, 30000);
//     return () => {
//       window.removeEventListener('resize', handleResize);
//       clearInterval(interval);
//     };
//   }, []);

//   const toggleSidebar = () => {
//     if (!isMobile) {
//       setIsSidebarOpen(!isSidebarOpen);
//     }
//   };
//   const toggleMobileSidebar = () => setIsMobileSidebarOpen(!isMobileSidebarOpen);

//   const handleLogout = () => {
//     setShowLogoutDialog(true);
//   };

//   const confirmLogout = () => {
//     localStorage.clear();
//     setShowLogoutDialog(false);
//     navigate('/client-login');
//   };

//   const cancelLogout = () => {
//     setShowLogoutDialog(false);
//   };

//   const handleMouseMove = (e, itemName) => {
//     setTooltipPosition({ x: e.clientX + 15, y: e.clientY - 10 });
//     setHoveredItem(itemName);
//   };

//   const toggleDropdown = (dropdownName) => {
//     setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
//   };

//   const menuSections = [
//     {
//       title: "Core",
//       items: [
//         { path: '/recruitment-dashboard', label: 'Dashboard', icon: FiGrid }
//       ]
//     },
//     {
//       title: "Job Management",
//       type: "dropdown",
//       items: [
//         { path: '/job-post', label: 'All Jobs', icon: FiFolder },
//         { path: '/post-new-job', label: 'Post New Job', icon: FiPlus, tag: { text: 'NEW', color: 'emerald' } },
//         { path: '/job-positions-status', label: 'Job Status', icon: FiActivity },
//         { path: '/job-applicants', label: 'Job Applicants', icon: FiUsers },
//         { path: '/score', label: 'Scores', icon: FiAward }
//       ]
//     },
//     {
//       title: "Short Jobs",
//       type: "dropdown",
//       items: [
//         { path: '/short-jobs', label: 'Post Short Job', icon: FiStar },
//         { path: '/posted-short-jobs', label: 'Posted Short Jobs', icon: FiList },
//         { path: '/short-job-applicants', label: 'Short Job Applicants', icon: FiUserCheck }
//       ]
//     },
//     {
//       title: "Assessments & Docs",
//       type: "dropdown",
//       items: [
//         { path: '/assessment-manager', label: 'All Assessments', icon: FiClipboard },
//         { path: '/new-assessment', label: 'Create Assessment', icon: FiFilePlus, tag: { text: 'NEW', color: 'emerald' } },
//         { path: '/personal-documents', label: 'Personal Docs', icon: FiFileText },
//         { path: '/all-medical-certificates', label: 'Medical Certificates', icon: FiHeart }
//       ]
//     },
//     {
//       title: "Communications",
//       type: "dropdown",
//       items: [
//         { path: '/acceptance-letter', label: 'Acceptance Letters', icon: FiMail },
//         { path: '/employee-journey', label: 'Employee Journey', icon: FiCompass }
//       ]
//     },
//     {
//       title: "Wallet & Rewards",
//       type: "dropdown",
//       items: [
//         { path: '/mywallet', label: 'My Wallet', icon: FiCreditCard },
//         { path: '/myreffral', label: 'Refer & Earn', icon: FiShare2 },
//         { path: '/specialoffers', label: 'Special Offers', icon: FiTag, tag: { text: 'HOT', color: 'orange', icon: FiZap } }
//       ]
//     }
//   ];

//   const allNavItems = menuSections.flatMap(section => section.items);

//   // Sidebar content for DESKTOP (can collapse/expand)
//   const DesktopSidebarContent = () => (
//     <div className="flex flex-col h-full relative bg-white border-r border-slate-200/80">
//       <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-indigo-500/20 to-transparent" />
      
//       {/* Header */}
//       <div className="relative flex items-center justify-between h-14 px-4 border-b border-slate-200/60 backdrop-blur-sm">
//         <div className={`flex items-center gap-2 transition-all duration-300 ${!isSidebarOpen && 'lg:hidden'}`}>
//           <motion.div whileHover={{ scale: 1.05 }} className="w-8 h-8 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-600 flex items-center justify-center text-white shadow-md">
//             <span className="text-xs font-bold">IG</span>
//           </motion.div>
//           <div>
//             <span className="font-bold text-slate-800 text-sm tracking-wide">INGRAIN-HIRE</span>
//             <p className="text-[9px] text-slate-500 font-semibold uppercase tracking-wider">Management</p>
//           </div>
//         </div>
        
//         {!isSidebarOpen && (
//           <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} className="hidden lg:block w-8 h-8 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-600 flex items-center justify-center shadow-md">
//             <span className="text-white font-bold text-xs">HR</span>
//           </motion.div>
//         )}
        
//         <button onClick={toggleSidebar} className="hidden lg:flex p-1.5 rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors">
//           <FiMenu size={18} />
//         </button>
//       </div>

//       <nav className="flex-1 px-3 py-3 overflow-y-auto custom-scrollbar space-y-1">
//         {menuSections.map((section, sectionIdx) => (
//           <div key={sectionIdx} className="mb-2">
//             {!isSidebarOpen ? (
//               <div className="space-y-1.5">
//                 {section.items?.map((item, idx) => (
//                   <div key={idx} className="relative">
//                     <NavLink
//                       to={item.path}
//                       onMouseEnter={(e) => handleMouseMove(e, item.label)}
//                       onMouseMove={(e) => handleMouseMove(e, item.label)}
//                       onMouseLeave={() => setHoveredItem(null)}
//                       className={({ isActive }) => `group relative flex items-center justify-center p-2.5 rounded-xl transition-all duration-200 ${
//                         isActive 
//                           ? 'bg-indigo-50 text-indigo-600 shadow-sm border border-indigo-100/50' 
//                           : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
//                       }`}
//                     >
//                       <item.icon size={18} className="transition-transform duration-200 group-hover:scale-110" />
//                     </NavLink>
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <>
//                 {section.title && !section.type && (
//                   <div className="px-3 mb-1.5 mt-3">
//                     <span className="text-[9px] font-bold uppercase tracking-wider text-slate-400">{section.title}</span>
//                   </div>
//                 )}
//                 {section.title && section.type && (
//                   <div className="px-3 mb-1.5 mt-3">
//                     <span className="text-[9px] font-bold uppercase tracking-wider text-slate-400">{section.title}</span>
//                   </div>
//                 )}
//                 <div className="space-y-0.5">
//                   {section.type === "dropdown" ? (
//                     <>
//                       <div 
//                         onClick={() => toggleDropdown(section.title)} 
//                         className={`flex items-center justify-between px-3 py-2.5 rounded-xl cursor-pointer transition-all duration-200 ${
//                           openDropdown === section.title 
//                             ? 'text-indigo-600 bg-indigo-50/40 font-medium' 
//                             : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
//                         }`}
//                       >
//                         <div className="flex items-center gap-3">
//                           {section.icon && <section.icon size={18} className={openDropdown === section.title ? 'text-indigo-500' : 'text-slate-400 group-hover:text-slate-600'} />}
//                           <span className="text-[13px] font-medium">{section.title}</span>
//                         </div>
//                         <FiChevronDown className={`transition-transform duration-300 text-slate-400 ${openDropdown === section.title ? 'rotate-180 text-indigo-500' : ''}`} size={14} />
//                       </div>
//                       <AnimatePresence>
//                         {openDropdown === section.title && (
//                           <motion.div 
//                             initial={{ opacity: 0, height: 0 }} 
//                             animate={{ opacity: 1, height: 'auto' }} 
//                             exit={{ opacity: 0, height: 0 }} 
//                             className="pl-3 mt-0.5 space-y-0.5 overflow-hidden border-l border-slate-100 ml-5"
//                           >
//                             {section.items.map((item, idx) => (
//                               <NavLink 
//                                 key={idx} 
//                                 to={item.path} 
//                                 className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-200 ${
//                                   isActive 
//                                     ? 'bg-indigo-50/70 text-indigo-600 font-semibold' 
//                                     : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50/50'
//                                 }`}
//                               >
//                                 {({ isActive }) => (
//                                   <>
//                                     <item.icon size={15} className={isActive ? 'text-indigo-500' : 'text-slate-400'} />
//                                     <span className="text-[12px]">{item.label}</span>
//                                     {item.tag && (
//                                       <span className={`text-[8px] font-bold px-1.5 py-0.5 rounded-full ${
//                                         item.tag.color === 'orange' 
//                                           ? 'bg-orange-50 text-orange-600 border border-orange-100' 
//                                           : 'bg-emerald-50 text-emerald-600 border border-emerald-100'
//                                       }`}>
//                                         {item.tag.text}
//                                       </span>
//                                     )}
//                                   </>
//                                 )}
//                               </NavLink>
//                             ))}
//                           </motion.div>
//                         )}
//                       </AnimatePresence>
//                     </>
//                   ) : (
//                     section.items?.map((item, idx) => (
//                       <NavLink 
//                         key={idx} 
//                         to={item.path} 
//                         className={({ isActive }) => `group flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-200 ${
//                           isActive 
//                             ? 'bg-gradient-to-r from-indigo-50 to-blue-50/30 text-indigo-600 font-semibold shadow-sm border border-indigo-100/50' 
//                             : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
//                         }`}
//                       >
//                         {({ isActive }) => (
//                           <>
//                             <item.icon size={18} className={`transition-colors ${isActive ? 'text-indigo-600' : 'text-slate-400 group-hover:text-slate-600'}`} />
//                             <div className="flex-1">
//                               <div className="flex items-center gap-2">
//                                 <span className="text-[13px] font-medium">{item.label}</span>
//                                 {item.tag && (
//                                   <span className={`text-[8px] font-bold px-1.5 py-0.5 rounded-full ${
//                                     item.tag.color === 'orange' 
//                                       ? 'bg-orange-50 text-orange-600 border border-orange-100' 
//                                       : 'bg-emerald-50 text-emerald-600 border border-emerald-100'
//                                   }`}>
//                                     {item.tag.text}
//                                   </span>
//                                 )}
//                               </div>
//                             </div>
//                             {isActive && (
//                               <motion.div 
//                                 layoutId="activeIndicator"
//                                 className="w-1.5 h-1.5 rounded-full bg-indigo-500"
//                               />
//                             )}
//                           </>
//                         )}
//                       </NavLink>
//                     ))
//                   )}
//                 </div>
//               </>
//             )}
//           </div>
//         ))}
//       </nav>

//       <div className="border-t border-slate-200/60 p-3">
//         {!isSidebarOpen ? (
//           <div className="flex flex-col items-center gap-2">
//             <button 
//               onClick={handleLogout} 
//               onMouseEnter={(e) => handleMouseMove(e, 'Sign Out')}
//               onMouseMove={(e) => handleMouseMove(e, 'Sign Out')}
//               onMouseLeave={() => setHoveredItem(null)}
//               className="p-2.5 rounded-xl text-red-500 hover:bg-red-50 hover:text-red-600 transition-all duration-200"
//             >
//               <FiLogOut size={18} />
//             </button>
//             <div className="mt-2 pt-2 border-t border-slate-200/60 w-full flex justify-center">
//               <div className="w-6 h-6 rounded-lg bg-slate-100 flex items-center justify-center">
//                 <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-blink" />
//               </div>
//             </div>
//           </div>
//         ) : (
//           <div className="space-y-2">
//             <button onClick={handleLogout} className="flex items-center gap-3 px-3 py-2.5 w-full rounded-xl text-red-500 hover:bg-red-50 hover:text-red-600 transition-all duration-200">
//               <FiLogOut size={18} className="text-red-400 group-hover:text-red-600" />
//               <div className="text-left">
//                 <span className="text-[13px] font-medium">Sign Out</span>
//                 <p className="text-[9px] text-slate-400">Exit application</p>
//               </div>
//             </button>
//             <div className="pt-3 mt-2 border-t border-slate-200/60">
//               <div className="flex items-center justify-between mb-1">
//                 <p className="text-slate-400 text-[8px] uppercase tracking-wider font-semibold">v2.0</p>
//                 <div className="flex items-center gap-1 px-2 py-0.5 bg-emerald-50 border border-emerald-200 rounded-full">
//                   <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-blink" />
//                   <span className="text-[8px] text-emerald-600 font-semibold uppercase tracking-wider">Live</span>
//                 </div>
//               </div>
//               <p className="text-[8px] text-slate-400">© 2026 Timely Health Care</p>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );

//   // Sidebar content for MOBILE (ALWAYS shows text)
//   const MobileSidebarContent = () => (
//     <div className="flex flex-col h-full relative bg-white w-64 border-r border-slate-200/80">
//       <div className="relative flex items-center justify-between h-14 px-4 border-b border-slate-200/60">
//         <div className="flex items-center gap-2">
//           <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-600 flex items-center justify-center text-white shadow-md">
//             <span className="text-xs font-bold">IG</span>
//           </div>
//           <div>
//             <span className="font-bold text-slate-800 text-sm tracking-wide">INGRAIN-HIRE</span>
//             <p className="text-[9px] text-slate-500 font-semibold uppercase tracking-wider">Management</p>
//           </div>
//         </div>
//         <button onClick={toggleMobileSidebar} className="p-1.5 rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors">
//           <FiX size={18} />
//         </button>
//       </div>

//       <nav className="flex-1 px-3 py-3 overflow-y-auto space-y-1">
//         {menuSections.map((section, sectionIdx) => (
//           <div key={sectionIdx} className="mb-2">
//             {section.title && (
//               <div className="px-3 mb-1.5 mt-3">
//                 <span className="text-[9px] font-bold uppercase tracking-wider text-slate-400">{section.title}</span>
//               </div>
//             )}
//             <div className="space-y-0.5">
//               {section.type === "dropdown" ? (
//                 <>
//                   <div 
//                     onClick={() => toggleDropdown(section.title)} 
//                     className={`flex items-center justify-between px-3 py-2.5 rounded-xl cursor-pointer transition-all duration-200 ${
//                       openDropdown === section.title 
//                         ? 'text-indigo-600 bg-indigo-50/40 font-medium' 
//                         : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
//                     }`}
//                   >
//                     <div className="flex items-center gap-3">
//                       {section.icon && <section.icon size={18} className={openDropdown === section.title ? 'text-indigo-500' : 'text-slate-400'} />}
//                       <span className="text-[13px] font-medium">{section.title}</span>
//                     </div>
//                     <FiChevronDown className={`transition-transform duration-300 text-slate-400 ${openDropdown === section.title ? 'rotate-180 text-indigo-500' : ''}`} size={14} />
//                   </div>
//                   <AnimatePresence>
//                     {openDropdown === section.title && (
//                       <motion.div 
//                         initial={{ opacity: 0, height: 0 }} 
//                         animate={{ opacity: 1, height: 'auto' }} 
//                         exit={{ opacity: 0, height: 0 }} 
//                         className="pl-3 mt-0.5 space-y-0.5 overflow-hidden border-l border-slate-100 ml-5"
//                       >
//                         {section.items.map((item, idx) => (
//                           <NavLink 
//                             key={idx} 
//                             to={item.path} 
//                             onClick={() => setIsMobileSidebarOpen(false)} 
//                             className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-200 ${
//                               isActive 
//                                 ? 'bg-indigo-50/70 text-indigo-600 font-semibold' 
//                                 : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50/50'
//                             }`}
//                           >
//                             {({ isActive }) => (
//                               <>
//                                 <item.icon size={15} className={isActive ? 'text-indigo-500' : 'text-slate-400'} />
//                                 <span className="text-[12px]">{item.label}</span>
//                                 {item.tag && (
//                                   <span className={`text-[8px] font-bold px-1.5 py-0.5 rounded-full ${
//                                     item.tag.color === 'orange' 
//                                       ? 'bg-orange-50 text-orange-600 border border-orange-100' 
//                                       : 'bg-emerald-50 text-emerald-600 border border-emerald-100'
//                                   }`}>
//                                     {item.tag.text}
//                                   </span>
//                                 )}
//                               </>
//                             )}
//                           </NavLink>
//                         ))}
//                       </motion.div>
//                     )}
//                   </AnimatePresence>
//                 </>
//               ) : (
//                 section.items?.map((item, idx) => (
//                   <NavLink 
//                     key={idx} 
//                     to={item.path} 
//                     onClick={() => setIsMobileSidebarOpen(false)} 
//                     className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-200 ${
//                       isActive 
//                         ? 'bg-gradient-to-r from-indigo-50 to-blue-50/30 text-indigo-600 font-semibold shadow-sm border border-indigo-100/50' 
//                         : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
//                     }`}
//                   >
//                     {({ isActive }) => (
//                       <>
//                         <item.icon size={18} className={isActive ? 'text-indigo-600' : 'text-slate-400'} />
//                         <span className="text-[13px] font-medium">{item.label}</span>
//                         {item.tag && (
//                           <span className={`text-[8px] font-bold px-1.5 py-0.5 rounded-full ${
//                             item.tag.color === 'orange' 
//                               ? 'bg-orange-50 text-orange-600 border border-orange-100' 
//                               : 'bg-emerald-50 text-emerald-600 border border-emerald-100'
//                           }`}>
//                             {item.tag.text}
//                           </span>
//                         )}
//                       </>
//                     )}
//                   </NavLink>
//                 ))
//               )}
//             </div>
//           </div>
//         ))}
//       </nav>

//       <div className="border-t border-slate-200/60 p-3">
//         <button onClick={handleLogout} className="flex items-center gap-3 px-3 py-2.5 w-full rounded-xl text-red-500 hover:bg-red-50 hover:text-red-600 transition-all duration-200">
//           <FiLogOut size={18} className="text-red-400 group-hover:text-red-600" />
//           <div className="text-left">
//             <span className="text-[13px] font-medium">Sign Out</span>
//             <p className="text-[9px] text-slate-400">Exit application</p>
//           </div>
//         </button>
//         <div className="pt-3 mt-2 border-t border-slate-200/60">
//           <div className="flex items-center justify-between mb-1">
//             <p className="text-slate-400 text-[8px] uppercase tracking-wider font-semibold">v2.0</p>
//             <div className="flex items-center gap-1 px-2 py-0.5 bg-emerald-50 border border-emerald-200 rounded-full">
//               <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-blink" />
//               <span className="text-[8px] text-emerald-600 font-semibold uppercase tracking-wider">Live</span>
//             </div>
//           </div>
//           <p className="text-[8px] text-slate-400">© 2026 Timely Health Care</p>
//         </div>
//       </div>
//     </div>
//   );

//   const Tooltip = () => {
//     if (!hoveredItem || isSidebarOpen || isMobile) return null;
//     return (
//       <div className="fixed z-[100] bg-gradient-to-r from-indigo-600 to-blue-600 text-white text-xs px-3 py-1.5 rounded-lg shadow-xl pointer-events-none whitespace-nowrap border border-indigo-400/30 animate-fade-in"
//         style={{ left: `${tooltipPosition.x}px`, top: `${tooltipPosition.y}px` }}
//       >
//         {hoveredItem}
//       </div>
//     );
//   };

//   return (
//     <div className="flex h-screen bg-white overflow-hidden font-sans text-slate-800">
//       <AnimatePresence>
//         {isMobileSidebarOpen && (
//           <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
//             className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40 lg:hidden"
//             onClick={toggleMobileSidebar}
//           />
//         )}
//       </AnimatePresence>

//       {/* Sidebar - Mobile and Desktop layouts */}
//       {isMobile ? (
//         <aside className={`fixed inset-y-0 left-0 z-50 transition-all duration-300 ease-in-out ${isMobileSidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}>
//           <MobileSidebarContent />
//         </aside>
//       ) : (
//         <aside className={`hidden lg:block transition-all duration-300 ease-in-out relative ${isSidebarOpen ? 'w-64' : 'w-16'}`}>
//           <DesktopSidebarContent />
//         </aside>
//       )}

//       {/* Main Content Area */}
//       <div className="flex-1 flex flex-col min-w-0 overflow-hidden relative">
//         <header className="sticky top-0 z-30 bg-white/95 border-b border-slate-200/80 shadow-slate-100/50 shadow-sm flex items-center justify-between px-4 lg:px-6 h-14 backdrop-blur-md">
//           <div className="flex items-center gap-4">
//             <button onClick={toggleMobileSidebar} className="lg:hidden p-2 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors">
//               <FiMenu size={20} />
//             </button>
            
//             <div className="flex items-center gap-2">
//               <span className="text-xs text-slate-500 font-medium hidden sm:inline">Recruitment</span>
//               <span className="text-slate-300 text-xs hidden sm:inline">/</span>
//               <span className="text-xs font-semibold text-slate-800 truncate max-w-[150px]">
//                 {allNavItems.find(item => item.path === location.pathname)?.label || 'Dashboard'}
//               </span>
//                 <span className="text-xs font-semibold text-slate-800 truncate max-w-[150px]">
//                 {allNavItems.find(item => item.path === location.pathname)?.label || 'Dashboard'}
//               </span>
//                 <span className="text-xs font-semibold text-slate-800 truncate max-w-[150px]">
//                 {allNavItems.find(item => item.path === location.pathname)?.label || 'Dashboard'}
//               </span>
//             </div>
//           </div>
          

        

//           <div className="flex items-center gap-3 sm:gap-4">
//             <div className="relative">
//               <motion.div whileHover={{ scale: 1.05 }} className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1 sm:py-1.5 rounded-xl bg-emerald-50 border border-emerald-200/80 shadow-sm">
//                 {walletLoading ? (
//                   <div className="w-10 sm:w-12 h-3 sm:h-4 bg-slate-100 rounded animate-pulse" />
//                 ) : (
//                   <div className="flex items-baseline gap-0.5 sm:gap-1">
//                     <span className="text-xs sm:text-sm font-bold text-emerald-700">
//                       {walletCoins !== null ? walletCoins : '---'}
//                     </span>
//                     <span className="text-[8px] sm:text-[9px] text-emerald-600 font-semibold uppercase tracking-wider">coins</span>
//                   </div>
//                 )}
//               </motion.div>
//             </div>

//             <div className="flex items-center gap-2 sm:gap-3">
//               <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-600 text-white flex items-center justify-center font-bold shadow-sm">
//                 <span className="text-xs sm:text-sm">HR</span>
//               </div>
//               <div className="hidden sm:block text-left">
//                 <p className="text-xs font-semibold text-slate-800">HR Manager</p>
//                 <p className="text-[10px] text-slate-500 font-medium font-sans">admin@timelyhealth.com</p>
//               </div>
//             </div>
//           </div>
//         </header>

//         <main className="flex-1 overflow-x-hidden overflow-y-auto p-3 sm:p-4 lg:p-6">
//           <div className="max-w-[1600px] mx-auto">
//             <Outlet />
//           </div>
//         </main>
//       </div>

//       <Tooltip />

//       {/* Logout Confirmation Dialog */}
//       {showLogoutDialog && (
//         <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 backdrop-blur-sm">
//           <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md mx-4 transform transition-all">
//             <div className="flex items-center gap-3 mb-4">
//               <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
//                 <FiLogOut className="text-red-600 text-xl" />
//               </div>
//               <h3 className="text-lg font-semibold text-gray-900">Confirm Logout</h3>
//             </div>
//             <p className="text-gray-600 mb-6">Are you sure you want to log out?</p>
//             <div className="flex justify-end gap-3">
//               <button
//                 onClick={cancelLogout}
//                 className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
//               >
//                 No
//               </button>
//               <button
//                 onClick={confirmLogout}
//                 className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors"
//               >
//                 Yes
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const styles = `
//   .custom-scrollbar::-webkit-scrollbar { width: 4px; height: 4px; }
//   .custom-scrollbar::-webkit-scrollbar-track { background: rgba(0, 0, 0, 0.03); border-radius: 10px; }
//   .custom-scrollbar::-webkit-scrollbar-thumb { background: rgba(99, 102, 241, 0.2); border-radius: 10px; }
//   .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: rgba(99, 102, 241, 0.4); }
//   @keyframes blink { 0%,100% { opacity:1; transform:scale(1); } 50% { opacity:0.4; transform:scale(0.8); } }
//   @keyframes fade-in { from { opacity:0; transform:translateX(-10px); } to { opacity:1; transform:translateX(0); } }
//   .animate-blink { animation: blink 1.5s ease-in-out infinite; }
//   .animate-fade-in { animation: fade-in 0.2s ease-out; }
// `;

// if (typeof document !== 'undefined') {
//   const styleSheet = document.createElement("style");
//   styleSheet.textContent = styles;
//   document.head.appendChild(styleSheet);
// }

// export default AdminLayout;





import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { 
  FiHome, FiBriefcase, FiUsers, FiBarChart2, FiMail, FiClipboard, FiFileText,
  FiMap, FiLogOut, FiMenu, FiX, FiFilePlus, FiPlusCircle, FiList, FiChevronDown,
  FiCreditCard, FiGift, FiTag, FiUserCheck, FiStar, FiTrendingUp, FiZap,
  FiGrid, FiActivity, FiAward, FiHeart, FiCompass, FiShare2, FiCheckSquare, FiPlus, FiFolder,
  FiFile, FiUpload, FiFolderPlus, FiBookOpen, FiEdit, FiLayers, FiChevronRight
} from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import axios from 'axios';

const AdminLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [walletCoins, setWalletCoins] = useState(null);
  const [walletLoading, setWalletLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const fetchWalletData = async () => {
    const clientId = localStorage.getItem('clientId');
    if (!clientId) return;
    setWalletLoading(true);
    try {
      const response = await axios.get(`https://api.ingrainsystems.com/api/clients/my-wallet/${clientId}`);
      console.log("Wallet API Response:", response.data);
      if (response.data.success) {
        // Fix: Use 'coins' instead of 'totalCoins'
        setWalletCoins(response.data.data.coins);
      }
    } catch (error) {
      console.error('Error fetching wallet data:', error);
    } finally {
      setWalletLoading(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      if (mobile) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    fetchWalletData();
    const interval = setInterval(fetchWalletData, 30000);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearInterval(interval);
    };
  }, []);

  const toggleSidebar = () => {
    if (!isMobile) {
      setIsSidebarOpen(!isSidebarOpen);
    }
  };
  const toggleMobileSidebar = () => setIsMobileSidebarOpen(!isMobileSidebarOpen);

  // Desktop Hover Expand
  const handleMouseEnterSidebar = () => {
    if (!isMobile) {
      setIsSidebarOpen(true);
    }
  };

  const handleMouseLeaveSidebar = () => {
    if (!isMobile && !openDropdown) {
      setIsSidebarOpen(false);
    }
  };

  const handleLogout = () => {
    setShowLogoutDialog(true);
  };

  const confirmLogout = () => {
    localStorage.clear();
    setShowLogoutDialog(false);
    navigate('/client-login');
  };

  const cancelLogout = () => {
    setShowLogoutDialog(false);
  };

  const handleMouseMove = (e, itemName) => {
    setTooltipPosition({ x: e.clientX + 15, y: e.clientY - 10 });
    setHoveredItem(itemName);
  };

  const toggleDropdown = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  const menuSections = [
    {
      title: "Core",
      items: [
        { path: '/recruitment-dashboard', label: 'Dashboard', icon: FiGrid }
      ]
    },
    {
      title: "Job Management",
      type: "dropdown",
      items: [
        { path: '/job-post', label: 'All Jobs', icon: FiFolder },
        { path: '/post-new-job', label: 'Post New Job', icon: FiPlus, tag: { text: 'NEW', color: 'emerald' } },
        { path: '/job-positions-status', label: 'Job Status', icon: FiActivity },
        { path: '/job-applicants', label: 'Job Applicants', icon: FiUsers },
        { path: '/score', label: 'Scores', icon: FiAward }
      ]
    },
    {
      title: "Short Jobs",
      type: "dropdown",
      items: [
        { path: '/short-jobs', label: 'Post Short Job', icon: FiStar },
        { path: '/posted-short-jobs', label: 'Posted Short Jobs', icon: FiList },
        { path: '/short-job-applicants', label: 'Short Job Applicants', icon: FiUserCheck }
      ]
    },
    {
      title: "Assessments & Docs",
      type: "dropdown",
      items: [
        { path: '/assessment-manager', label: 'All Assessments', icon: FiClipboard },
        { path: '/new-assessment', label: 'Create Assessment', icon: FiFilePlus, tag: { text: 'NEW', color: 'emerald' } },
        { path: '/personal-documents', label: 'Personal Docs', icon: FiFileText },
        { path: '/all-medical-certificates', label: 'Medical Certificates', icon: FiHeart }
      ]
    },
    {
      title: "Communications",
      type: "dropdown",
      items: [
        { path: '/acceptance-letter', label: 'Acceptance Letters', icon: FiMail },
        { path: '/employee-journey', label: 'Employee Journey', icon: FiCompass }
      ]
    },
    {
      title: "Wallet & Rewards",
      type: "dropdown",
      items: [
        { path: '/mywallet', label: 'My Wallet', icon: FiCreditCard },
        { path: '/myreffral', label: 'Refer & Earn', icon: FiShare2 },
        { path: '/specialoffers', label: 'Special Offers', icon: FiTag, tag: { text: 'HOT', color: 'orange', icon: FiZap } }
      ]
    }
  ];

  const allNavItems = menuSections.flatMap(section => section.items);

  // Find the current active section and items
  const getCurrentSectionInfo = () => {
    for (const section of menuSections) {
      if (section.items) {
        const found = section.items.find(item => item.path === location.pathname);
        if (found) {
          return {
            sectionTitle: section.title,
            items: section.items,
            currentItem: found
          };
        }
      }
    }
    return null;
  };

  const currentSectionInfo = getCurrentSectionInfo();

  // Sidebar content for DESKTOP (can collapse/expand)
  const DesktopSidebarContent = () => (
    <div className="flex flex-col h-full relative bg-white border-r border-slate-200/80">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-indigo-500/20 to-transparent" />
      
      {/* Header */}
      <div className="relative flex items-center justify-between h-14 px-4 border-b border-slate-200/60 backdrop-blur-sm">
        <div className={`flex items-center gap-2 transition-all duration-300 ${!isSidebarOpen && 'lg:hidden'}`}>
          <motion.div whileHover={{ scale: 1.05 }} className="w-8 h-8 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-600 flex items-center justify-center text-white shadow-md">
            <span className="text-xs font-bold">IG</span>
          </motion.div>
          <div>
            <span className="font-bold text-slate-800 text-sm tracking-wide">INGRAIN-HIRE</span>
            <p className="text-[9px] text-slate-500 font-semibold uppercase tracking-wider">Management</p>
          </div>
        </div>
        
        {!isSidebarOpen && (
          <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} className="hidden lg:block w-8 h-8 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-600 flex items-center justify-center shadow-md">
            <span className="text-white font-bold text-xs">HR</span>
          </motion.div>
        )}
        
        <button onClick={toggleSidebar} className="hidden lg:flex p-1.5 rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors">
          <FiMenu size={18} />
        </button>
      </div>

      <nav className="flex-1 px-3 py-3 overflow-y-auto custom-scrollbar space-y-1">
        {menuSections.map((section, sectionIdx) => (
          <div key={sectionIdx} className="mb-2">
            {!isSidebarOpen ? (
              <div className="space-y-1.5">
                {section.items?.map((item, idx) => (
                  <div key={idx} className="relative">
                    <NavLink
                      to={item.path}
                      onMouseEnter={(e) => handleMouseMove(e, item.label)}
                      onMouseMove={(e) => handleMouseMove(e, item.label)}
                      onMouseLeave={() => setHoveredItem(null)}
                      className={({ isActive }) => `group relative flex items-center justify-center p-2.5 rounded-xl transition-all duration-200 ${
                        isActive 
                          ? 'bg-indigo-50 text-indigo-600 shadow-sm border border-indigo-100/50' 
                          : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                      }`}
                    >
                      <item.icon size={18} className="transition-transform duration-200 group-hover:scale-110" />
                    </NavLink>
                  </div>
                ))}
              </div>
            ) : (
              <>
                {section.title && !section.type && (
                  <div className="px-3 mb-1.5 mt-3">
                    <span className="text-[9px] font-bold uppercase tracking-wider text-slate-400">{section.title}</span>
                  </div>
                )}
                {section.title && section.type && (
                  <div className="px-3 mb-1.5 mt-3">
                    <span className="text-[9px] font-bold uppercase tracking-wider text-slate-400">{section.title}</span>
                  </div>
                )}
                <div className="space-y-0.5">
                  {section.type === "dropdown" ? (
                    <>
                      <div 
                        onClick={() => toggleDropdown(section.title)} 
                        className={`flex items-center justify-between px-3 py-2.5 rounded-xl cursor-pointer transition-all duration-200 ${
                          openDropdown === section.title 
                            ? 'text-indigo-600 bg-indigo-50/40 font-medium' 
                            : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                        }`}
                      >
                        <div className="flex items-center gap-3">
                          {section.icon && <section.icon size={18} className={openDropdown === section.title ? 'text-indigo-500' : 'text-slate-400 group-hover:text-slate-600'} />}
                          <span className="text-[13px] font-medium">{section.title}</span>
                        </div>
                        <FiChevronDown className={`transition-transform duration-300 text-slate-400 ${openDropdown === section.title ? 'rotate-180 text-indigo-500' : ''}`} size={14} />
                      </div>
                      <AnimatePresence>
                        {openDropdown === section.title && (
                          <motion.div 
                            initial={{ opacity: 0, height: 0 }} 
                            animate={{ opacity: 1, height: 'auto' }} 
                            exit={{ opacity: 0, height: 0 }} 
                            className="pl-3 mt-0.5 space-y-0.5 overflow-hidden border-l border-slate-100 ml-5"
                          >
                            {section.items.map((item, idx) => (
                              <NavLink 
                                key={idx} 
                                to={item.path} 
                                className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-200 ${
                                  isActive 
                                    ? 'bg-indigo-50/70 text-indigo-600 font-semibold' 
                                    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50/50'
                                }`}
                              >
                                {({ isActive }) => (
                                  <>
                                    <item.icon size={15} className={isActive ? 'text-indigo-500' : 'text-slate-400'} />
                                    <span className="text-[12px]">{item.label}</span>
                                    {item.tag && (
                                      <span className={`text-[8px] font-bold px-1.5 py-0.5 rounded-full ${
                                        item.tag.color === 'orange' 
                                          ? 'bg-orange-50 text-orange-600 border border-orange-100' 
                                          : 'bg-emerald-50 text-emerald-600 border border-emerald-100'
                                      }`}>
                                        {item.tag.text}
                                      </span>
                                    )}
                                  </>
                                )}
                              </NavLink>
                            ))}
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </>
                  ) : (
                    section.items?.map((item, idx) => (
                      <NavLink 
                        key={idx} 
                        to={item.path} 
                        className={({ isActive }) => `group flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-200 ${
                          isActive 
                            ? 'bg-gradient-to-r from-indigo-50 to-blue-50/30 text-indigo-600 font-semibold shadow-sm border border-indigo-100/50' 
                            : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                        }`}
                      >
                        {({ isActive }) => (
                          <>
                            <item.icon size={18} className={`transition-colors ${isActive ? 'text-indigo-600' : 'text-slate-400 group-hover:text-slate-600'}`} />
                            <div className="flex-1">
                              <div className="flex items-center gap-2">
                                <span className="text-[13px] font-medium">{item.label}</span>
                                {item.tag && (
                                  <span className={`text-[8px] font-bold px-1.5 py-0.5 rounded-full ${
                                    item.tag.color === 'orange' 
                                      ? 'bg-orange-50 text-orange-600 border border-orange-100' 
                                      : 'bg-emerald-50 text-emerald-600 border border-emerald-100'
                                  }`}>
                                    {item.tag.text}
                                  </span>
                                )}
                              </div>
                            </div>
                            {isActive && (
                              <motion.div 
                                layoutId="activeIndicator"
                                className="w-1.5 h-1.5 rounded-full bg-indigo-500"
                              />
                            )}
                          </>
                        )}
                      </NavLink>
                    ))
                  )}
                </div>
              </>
            )}
          </div>
        ))}
      </nav>

      <div className="border-t border-slate-200/60 p-3">
        {!isSidebarOpen ? (
          <div className="flex flex-col items-center gap-2">
            <button 
              onClick={handleLogout} 
              onMouseEnter={(e) => handleMouseMove(e, 'Sign Out')}
              onMouseMove={(e) => handleMouseMove(e, 'Sign Out')}
              onMouseLeave={() => setHoveredItem(null)}
              className="p-2.5 rounded-xl text-red-500 hover:bg-red-50 hover:text-red-600 transition-all duration-200"
            >
              <FiLogOut size={18} />
            </button>
            <div className="mt-2 pt-2 border-t border-slate-200/60 w-full flex justify-center">
              <div className="w-6 h-6 rounded-lg bg-slate-100 flex items-center justify-center">
                <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-blink" />
              </div>
            </div>
          </div>
        ) : (
          <div className="space-y-2">
            <button onClick={handleLogout} className="flex items-center gap-3 px-3 py-2.5 w-full rounded-xl text-red-500 hover:bg-red-50 hover:text-red-600 transition-all duration-200">
              <FiLogOut size={18} className="text-red-400 group-hover:text-red-600" />
              <div className="text-left">
                <span className="text-[13px] font-medium">Sign Out</span>
                <p className="text-[9px] text-slate-400">Exit application</p>
              </div>
            </button>
            <div className="pt-3 mt-2 border-t border-slate-200/60">
              <div className="flex items-center justify-between mb-1">
                <p className="text-slate-400 text-[8px] uppercase tracking-wider font-semibold">v2.0</p>
                <div className="flex items-center gap-1 px-2 py-0.5 bg-emerald-50 border border-emerald-200 rounded-full">
                  <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-blink" />
                  <span className="text-[8px] text-emerald-600 font-semibold uppercase tracking-wider">Live</span>
                </div>
              </div>
              <p className="text-[8px] text-slate-400">© 2026 Timely Health Care</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  // Sidebar content for MOBILE (ALWAYS shows text)
  const MobileSidebarContent = () => (
    <div className="flex flex-col h-full relative bg-white w-64 border-r border-slate-200/80">
      <div className="relative flex items-center justify-between h-14 px-4 border-b border-slate-200/60">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-600 flex items-center justify-center text-white shadow-md">
            <span className="text-xs font-bold">IG</span>
          </div>
          <div>
            <span className="font-bold text-slate-800 text-sm tracking-wide">INGRAIN-HIRE</span>
            <p className="text-[9px] text-slate-500 font-semibold uppercase tracking-wider">Management</p>
          </div>
        </div>
        <button onClick={toggleMobileSidebar} className="p-1.5 rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors">
          <FiX size={18} />
        </button>
      </div>

      <nav className="flex-1 px-3 py-3 overflow-y-auto space-y-1">
        {menuSections.map((section, sectionIdx) => (
          <div key={sectionIdx} className="mb-2">
            {section.title && (
              <div className="px-3 mb-1.5 mt-3">
                <span className="text-[9px] font-bold uppercase tracking-wider text-slate-400">{section.title}</span>
              </div>
            )}
            <div className="space-y-0.5">
              {section.type === "dropdown" ? (
                <>
                  <div 
                    onClick={() => toggleDropdown(section.title)} 
                    className={`flex items-center justify-between px-3 py-2.5 rounded-xl cursor-pointer transition-all duration-200 ${
                      openDropdown === section.title 
                        ? 'text-indigo-600 bg-indigo-50/40 font-medium' 
                        : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      {section.icon && <section.icon size={18} className={openDropdown === section.title ? 'text-indigo-500' : 'text-slate-400'} />}
                      <span className="text-[13px] font-medium">{section.title}</span>
                    </div>
                    <FiChevronDown className={`transition-transform duration-300 text-slate-400 ${openDropdown === section.title ? 'rotate-180 text-indigo-500' : ''}`} size={14} />
                  </div>
                  <AnimatePresence>
                    {openDropdown === section.title && (
                      <motion.div 
                        initial={{ opacity: 0, height: 0 }} 
                        animate={{ opacity: 1, height: 'auto' }} 
                        exit={{ opacity: 0, height: 0 }} 
                        className="pl-3 mt-0.5 space-y-0.5 overflow-hidden border-l border-slate-100 ml-5"
                      >
                        {section.items.map((item, idx) => (
                          <NavLink 
                            key={idx} 
                            to={item.path} 
                            onClick={() => setIsMobileSidebarOpen(false)} 
                            className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-200 ${
                              isActive 
                                ? 'bg-indigo-50/70 text-indigo-600 font-semibold' 
                                : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50/50'
                            }`}
                          >
                            {({ isActive }) => (
                              <>
                                <item.icon size={15} className={isActive ? 'text-indigo-500' : 'text-slate-400'} />
                                <span className="text-[12px]">{item.label}</span>
                                {item.tag && (
                                  <span className={`text-[8px] font-bold px-1.5 py-0.5 rounded-full ${
                                    item.tag.color === 'orange' 
                                      ? 'bg-orange-50 text-orange-600 border border-orange-100' 
                                      : 'bg-emerald-50 text-emerald-600 border border-emerald-100'
                                  }`}>
                                    {item.tag.text}
                                  </span>
                                )}
                              </>
                            )}
                          </NavLink>
                        ))}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </>
              ) : (
                section.items?.map((item, idx) => (
                  <NavLink 
                    key={idx} 
                    to={item.path} 
                    onClick={() => setIsMobileSidebarOpen(false)} 
                    className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-200 ${
                      isActive 
                        ? 'bg-gradient-to-r from-indigo-50 to-blue-50/30 text-indigo-600 font-semibold shadow-sm border border-indigo-100/50' 
                        : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                    }`}
                  >
                    {({ isActive }) => (
                      <>
                        <item.icon size={18} className={isActive ? 'text-indigo-600' : 'text-slate-400'} />
                        <span className="text-[13px] font-medium">{item.label}</span>
                        {item.tag && (
                          <span className={`text-[8px] font-bold px-1.5 py-0.5 rounded-full ${
                            item.tag.color === 'orange' 
                              ? 'bg-orange-50 text-orange-600 border border-orange-100' 
                              : 'bg-emerald-50 text-emerald-600 border border-emerald-100'
                          }`}>
                            {item.tag.text}
                          </span>
                        )}
                      </>
                    )}
                  </NavLink>
                ))
              )}
            </div>
          </div>
        ))}
      </nav>

      <div className="border-t border-slate-200/60 p-3">
        <button onClick={handleLogout} className="flex items-center gap-3 px-3 py-2.5 w-full rounded-xl text-red-500 hover:bg-red-50 hover:text-red-600 transition-all duration-200">
          <FiLogOut size={18} className="text-red-400 group-hover:text-red-600" />
          <div className="text-left">
            <span className="text-[13px] font-medium">Sign Out</span>
            <p className="text-[9px] text-slate-400">Exit application</p>
          </div>
        </button>
        <div className="pt-3 mt-2 border-t border-slate-200/60">
          <div className="flex items-center justify-between mb-1">
            <p className="text-slate-400 text-[8px] uppercase tracking-wider font-semibold">v2.0</p>
            <div className="flex items-center gap-1 px-2 py-0.5 bg-emerald-50 border border-emerald-200 rounded-full">
              <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-blink" />
              <span className="text-[8px] text-emerald-600 font-semibold uppercase tracking-wider">Live</span>
            </div>
          </div>
          <p className="text-[8px] text-slate-400">© 2026 Timely Health Care</p>
        </div>
      </div>
    </div>
  );

  const Tooltip = () => {
    if (!hoveredItem || isSidebarOpen || isMobile) return null;
    return (
      <div className="fixed z-[100] bg-gradient-to-r from-indigo-600 to-blue-600 text-white text-xs px-3 py-1.5 rounded-lg shadow-xl pointer-events-none whitespace-nowrap border border-indigo-400/30 animate-fade-in"
        style={{ left: `${tooltipPosition.x}px`, top: `${tooltipPosition.y}px` }}
      >
        {hoveredItem}
      </div>
    );
  };

  return (
    <div className="flex h-screen bg-white overflow-hidden font-sans text-slate-800">
      <AnimatePresence>
        {isMobileSidebarOpen && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40 lg:hidden"
            onClick={toggleMobileSidebar}
          />
        )}
      </AnimatePresence>

      {/* Sidebar - Mobile and Desktop layouts */}
      {isMobile ? (
        <aside className={`fixed inset-y-0 left-0 z-50 transition-all duration-300 ease-in-out ${isMobileSidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}>
          <MobileSidebarContent />
        </aside>
      ) : (
        <aside 
          onMouseEnter={handleMouseEnterSidebar}
          onMouseLeave={handleMouseLeaveSidebar}
          className={`hidden lg:block transition-all duration-300 ease-in-out relative ${isSidebarOpen ? 'w-64' : 'w-16'}`}
        >
          <DesktopSidebarContent />
        </aside>
      )}

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden relative">
        <header className="sticky top-0 z-30 bg-white/95 border-b border-slate-200/80 shadow-slate-100/50 shadow-sm flex items-center justify-between px-4 lg:px-6 h-14 backdrop-blur-md">
          <div className="flex items-center gap-4">
            <button onClick={toggleMobileSidebar} className="lg:hidden p-2 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors">
              <FiMenu size={20} />
            </button>
            
            {/* Breadcrumb Navigation */}
            <div className="flex items-center gap-2">
              <span className="text-xs font-semibold text-indigo-600">{currentSectionInfo?.sectionTitle || 'Recruitment'}</span>
              {currentSectionInfo && currentSectionInfo.items.length > 0 && (
                <>
                  <span className="text-slate-300 text-xs">/</span>
                  <div className="flex items-center gap-1 flex-wrap">
                    {currentSectionInfo.items.map((item, index) => {
                      const isActive = location.pathname === item.path;
                      // Skip rendering the active page link
                      if (isActive) {
                        return null;
                      }
                      return (
                        <React.Fragment key={index}>
                          {index > 0 && <span className="text-slate-300 text-[10px]">•</span>}
                          <NavLink
                            to={item.path}
                            className="text-xs text-slate-500 hover:text-indigo-600 transition-colors duration-200 hover:underline"
                          >
                            {item.label}
                          </NavLink>
                        </React.Fragment>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="flex items-center gap-3 sm:gap-4">
            <div className="relative">
              <motion.div whileHover={{ scale: 1.05 }} className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1 sm:py-1.5 rounded-xl bg-emerald-50 border border-emerald-200/80 shadow-sm">
                {walletLoading ? (
                  <div className="w-10 sm:w-12 h-3 sm:h-4 bg-slate-100 rounded animate-pulse" />
                ) : (
                  <div className="flex items-baseline gap-0.5 sm:gap-1">
                    <span className="text-xs sm:text-sm font-bold text-emerald-700">
                      {walletCoins !== null ? walletCoins : '---'}
                    </span>
                    <span className="text-[8px] sm:text-[9px] text-emerald-600 font-semibold uppercase tracking-wider">coins</span>
                  </div>
                )}
              </motion.div>
            </div>

            <div className="flex items-center gap-2 sm:gap-3">
              <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-600 text-white flex items-center justify-center font-bold shadow-sm">
                <span className="text-xs sm:text-sm">HR</span>
              </div>
              <div className="hidden sm:block text-left">
                <p className="text-xs font-semibold text-slate-800">HR Manager</p>
                <p className="text-[10px] text-slate-500 font-medium font-sans">admin@timelyhealth.com</p>
              </div>
            </div>
          </div>
        </header>

        <main className="flex-1 overflow-x-hidden overflow-y-auto p-3 sm:p-4 lg:p-6">
          <div className="max-w-[1600px] mx-auto">
            <Outlet />
          </div>
        </main>
      </div>

      <Tooltip />

      {/* Logout Confirmation Dialog */}
      {showLogoutDialog && (
        <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md mx-4 transform transition-all">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
                <FiLogOut className="text-red-600 text-xl" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">Confirm Logout</h3>
            </div>
            <p className="text-gray-600 mb-6">Are you sure you want to log out?</p>
            <div className="flex justify-end gap-3">
              <button
                onClick={cancelLogout}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
              >
                No
              </button>
              <button
                onClick={confirmLogout}
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = `
  .custom-scrollbar::-webkit-scrollbar { width: 4px; height: 4px; }
  .custom-scrollbar::-webkit-scrollbar-track { background: rgba(0, 0, 0, 0.03); border-radius: 10px; }
  .custom-scrollbar::-webkit-scrollbar-thumb { background: rgba(99, 102, 241, 0.2); border-radius: 10px; }
  .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: rgba(99, 102, 241, 0.4); }
  @keyframes blink { 0%,100% { opacity:1; transform:scale(1); } 50% { opacity:0.4; transform:scale(0.8); } }
  @keyframes fade-in { from { opacity:0; transform:translateX(-10px); } to { opacity:1; transform:translateX(0); } }
  .animate-blink { animation: blink 1.5s ease-in-out infinite; }
  .animate-fade-in { animation: fade-in 0.2s ease-out; }
`;

if (typeof document !== 'undefined') {
  const styleSheet = document.createElement("style");
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}

export default AdminLayout;